/**
 * CX-5/6/7 seed data: NPS + CSAT surveys, customer onboarding apps.
 */
import { DEMO_TENANT_ID } from './tenantDefaults';

const TENANT = DEMO_TENANT_ID;
const iso = (days) => new Date(Date.now() - days * 86400000).toISOString();

export const SEED_NPS_SURVEYS = [
  // Riverside — happy overall
  { id: 'nps-0001', tenantId: TENANT, customerId: 'cust-riverside', customerName: 'Riverside Natural Foods', loadId: 'load-00001', score: 9, category: 'promoter', comment: 'On time, good comms', submittedAt: iso(14) },
  { id: 'nps-0002', tenantId: TENANT, customerId: 'cust-riverside', customerName: 'Riverside Natural Foods', loadId: 'load-00002', score: 10, category: 'promoter', comment: 'AEGIS updates are awesome', submittedAt: iso(21) },
  { id: 'nps-0003', tenantId: TENANT, customerId: 'cust-riverside', customerName: 'Riverside Natural Foods', loadId: 'load-00003', score: 7, category: 'passive', comment: 'Late arrival once', submittedAt: iso(35) },
  // Watchmen — mixed
  { id: 'nps-0004', tenantId: TENANT, customerId: 'cust-watchmen', customerName: 'Watchmen Logistics', loadId: 'load-00008', score: 8, category: 'passive', comment: '', submittedAt: iso(7) },
  { id: 'nps-0005', tenantId: TENANT, customerId: 'cust-watchmen', customerName: 'Watchmen Logistics', loadId: 'load-00009', score: 5, category: 'detractor', comment: 'Missed appointment window', submittedAt: iso(12) },
  { id: 'nps-0006', tenantId: TENANT, customerId: 'cust-watchmen', customerName: 'Watchmen Logistics', loadId: 'load-00010', score: 3, category: 'detractor', comment: 'Two late deliveries in a row', submittedAt: iso(28) },
  // Sunbelt — loyal
  { id: 'nps-0007', tenantId: TENANT, customerId: 'cust-sunbelt', customerName: 'Sunbelt Produce', loadId: 'load-00015', score: 10, category: 'promoter', submittedAt: iso(10) },
  { id: 'nps-0008', tenantId: TENANT, customerId: 'cust-sunbelt', customerName: 'Sunbelt Produce', loadId: 'load-00017', score: 9, category: 'promoter', submittedAt: iso(45) },
];

export const SEED_CSAT_SURVEYS = [
  { id: 'csat-0001', tenantId: TENANT, customerId: 'cust-riverside', customerName: 'Riverside Natural Foods', loadId: 'load-00001', score: 5, comment: '', submittedAt: iso(14) },
  { id: 'csat-0002', tenantId: TENANT, customerId: 'cust-riverside', customerName: 'Riverside Natural Foods', loadId: 'load-00002', score: 5, submittedAt: iso(21) },
  { id: 'csat-0003', tenantId: TENANT, customerId: 'cust-watchmen', customerName: 'Watchmen Logistics', loadId: 'load-00009', score: 3, comment: 'Missed window', submittedAt: iso(12) },
  { id: 'csat-0004', tenantId: TENANT, customerId: 'cust-sunbelt', customerName: 'Sunbelt Produce', loadId: 'load-00015', score: 5, submittedAt: iso(10) },
];

export const SEED_CUSTOMER_ONBOARDING_APPS = [
  {
    id: 'cust-app-0001', tenantId: TENANT, companyName: 'Apex Medical Supply',
    contactEmail: 'ops@apexmedical.com', slaTier: 'Gold',
    status: 'in_progress', completedSteps: ['profile', 'sla'],
    createdAt: iso(2),
  },
  {
    id: 'cust-app-0002', tenantId: TENANT, companyName: 'Midwest Grocers',
    contactEmail: 'logistics@midwestgrocers.com', slaTier: 'Silver',
    status: 'ready_to_activate', completedSteps: ['profile', 'sla', 'rates', 'contact', 'contract'],
    contract: { startDate: new Date().toISOString().slice(0, 10), endDate: iso(-365).slice(0, 10), terms: 'NET30', pdfUrl: 'seed://midwest-msa.pdf' },
    createdAt: iso(5),
  },
];

export const SEED_CUSTOMER_CONTRACTS = [
  { id: 'cc-0001', tenantId: TENANT, customerId: 'cust-riverside', startDate: iso(365).slice(0,10), endDate: iso(-365).slice(0,10), terms: 'NET30, weekly invoicing', slaTier: 'Gold', pdfUrl: 'seed://riverside-msa.pdf' },
  { id: 'cc-0002', tenantId: TENANT, customerId: 'cust-watchmen', startDate: iso(200).slice(0,10), endDate: iso(-165).slice(0,10), terms: 'NET45', slaTier: 'Silver', pdfUrl: 'seed://watchmen-msa.pdf' },
];

export const CX_SEED_SUMMARY = {
  nps_surveys: SEED_NPS_SURVEYS.length,
  csat_surveys: SEED_CSAT_SURVEYS.length,
  customer_onboarding_applications: SEED_CUSTOMER_ONBOARDING_APPS.length,
  customer_contracts: SEED_CUSTOMER_CONTRACTS.length,
};
